export default __webpack_public_path__ + "static/3-9d577f898909c6367bd188e6c535643d.jpg";